import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('PaymentCalculatorWrapper')(() => css({
    maxHeight: ['calc(100svh - 178px)', 'calc(100svh - 178px)', '483px'],
    overflowY: 'scroll',
    overflowX: 'hidden',
    mr: ['-10px', '-10px', '-30px'],
    pr: ['10px', '10px', '30px'],
}));
export default themeStyles;
